/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Grid } from '@mui/material';
import React from 'react'
import { Box } from '@mui/system';
import UserCreation from '../views/admin/UserCreation';
import UsersList from '../views/admin/UsersList';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import AdminUsersCount from '../views/admin/AdminUsersCount';
import SearchAdminUser from '../views/admin/SearchAdminUser';

const ManageAdminUsersPage = () => {
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Admin Users'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6}>
                        <UserCreation />
                        <AdminUsersCount />

                    </Grid>
                    <Grid item xs={12} sm={10} md={6}>
                        <SearchAdminUser />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <UsersList />
                    </Grid>
                </Grid>
            </Box>

        </>
    )
}

export default ManageAdminUsersPage;